import React from "react";

const MobileWork = () => {
  return (
    <div>
      <div className="flex flex-col">
        
        <div className="flex flex-col p-3 items-center font-display font-bold text-navy">
          <div className="text-6xl whitespace-nowrap text-center">#7</div>
          <div className="text-2xl text-center mt-5">
            Ranked Glazier in the <br />
            Nation by Engineering News-Record
          </div>
        </div>
        <div className="flex font-display font-bold text-navy items-center justify-center text-center pr-6">
          <img
            src={"/various/enrlogo.webp"}
            className="w-1/2 object-contain p-8"
          />
          <div className="p-2">
            We are experts in our craft and hold ourselves to the highest
            standards throughout each project.
          </div>
        </div>
        <div
          className="bg-cover"
          style={{ backgroundImage: `url(${"../images/380stuart.webp"})` }}
        >
          <img src={"/various/whatwedo-new2.webp"} className="" />
        </div>
      </div>
    </div>
  );
};

export default MobileWork;
